import { BillingState } from '@monolith/legacy/store/account/billing/index';
import { AnkorstoreBillingExport } from '@client/api-internal/data-contracts';

export const mutations = {
  SET_EXPORT_LIST(state: BillingState, exportList: AnkorstoreBillingExport[]) {
    state.exportList = [...exportList];
  },
  SET_HAS_FINANCE_CONTACT(state: BillingState, value: boolean) {
    state.hasFinanceContact = value;
  },
};
